<template>
  <div class="content page-content" v-loading="loading">
    <ListButton :buttonObj="buttonObj" :buttonList="buttonList" :selected="selected" @create="handleCreate" v-on:clickType="OnCheckList"></ListButton>
    <el-row>
      <Table
        class="order-table"
        :props="table.props"
        :header="tableHeader"
        :data="table.data"
        :selection-type="table.selectionType"
        :selected="table.selected"
        @row-selection-add="handleRowSelectionAdd"
        @row-selection-remove="handleRowSelectionRemove"
        @all-row-selection-change="handleAllRowSelectionChange"
      />
      <pagination
        v-bind:currentpage="currentPage"
        v-bind:pagesize="pageSize"
        v-bind:totalcount="totalCount"
        @handle-size-change="handleSizeChange"
        @handle-current-change="handleCurrentChange"
      ></pagination>
    </el-row>
    <template></template>
    <!-- 订单详情 -->
    <el-drawer :visible.sync="drawer" size="60%" :modal="false" :destroy-on-close="true" class="detail-drawer" :with-header="false">
      <Read v-if="drawer" :id="detailOrderId" :flage="flage" :init-mode="mode" :price-data="priceData" @handleCloseDraw="handleCloseDraw"></Read>
    </el-drawer>
  </div>
</template>
<script>
import { Table } from '@ccprivate/admin-toolkit'
import ListButton from '@/components/ListButton'
import InputIconEdit from '@/components/InputIconEdit'
import Read from './ProjectOrderRead'
import { debounce } from 'lodash'
export default {
  components: {
    Table,
    ListButton,
    Read
  },
  inject: ['projectOrder'],
  data() {
    return {
      mode: 'edit',
      buttonObj: {
        title: '项目',
        permissionData: 'order:create'
      },
      buttonList: [
        {
          icon: 'el-icon-caret-right',
          title: '启用',
          key: 'start',
          permission: 'order:operate',
          disabled: true,
          type: 'button'
        },
        {
          icon: 'el-icon-cc-pause',
          title: '暂停',
          key: 'pause',
          permission: 'order:operate',
          disabled: true,
          type: 'button'
        },
        {
          icon: 'el-icon-cc-wancheng',
          title: '结束',
          key: 'end',
          permission: 'order:operate',
          disabled: true,
          type: 'button'
        },
        {
          icon: 'el-icon-cc-lajitong',
          title: '删除',
          key: 'del',
          permission: 'order:operate',
          disabled: true,
          type: 'button'
        }
      ],
      buttonListMethodMaps: {
        start: this.handleStartOrder,
        pause: this.handlePauseOrder,
        end: this.handleEndOrder,
        del: this.handleDelOrder
      },
      loading: false,
      dialogTableVisible: false,
      showClose: false,
      checkTableHeader: [],
      priceData: [],
      pageSize: 10,
      // 当前页码:pageNum
      currentPage: 1,
      totalCount: 1,
      // 查询的页码
      start: 1,
      filter: {},
      isShowPopover: false,
      drawer: false,
      flage: '',
      table: {
        props: {
          border: true,
          stripe: false,
          'tooltip-effect': 'dark'
        },
        header: [
          {
            label: '订单编号',
            align: 'left',
            prop: 'orderNo',
            fixed: 'left',
            isShow: true,
            'min-width': 155,
            'show-overflow-tooltip': true
          },
          {
            label: '订单名称',
            align: 'left',
            prop: 'orderName',
            fixed: 'left',
            isShow: true,
            'min-width': 300,
            'show-overflow-tooltip': true,
            render: (h, { row }) => {
              return h(InputIconEdit, {
                props: {
                  initValue: row.orderName,
                  listName: 'order',
                  currentTableData: row,
                  permission: 'order:edit',
                  disabled: row.orderStatus === -1
                },
                on: {
                  confirm: (value) => {
                    this.$service
                      .updateOrder(
                        {
                          ids: [row.orderId],
                          operateType: 6,
                          orderName: value
                        },
                        '操作成功'
                      )
                      .then((data) => {
                        row.orderName = value
                        // this.fetchData()
                      })
                  }
                }
              })
            }
          },
          {
            label: '广告主',
            align: 'left',
            prop: 'partnerName',
            width: 200,
            isShow: this.projectOrder.accountType === '1',
            'show-overflow-tooltip': true
          },
          {
            label: '状态',
            align: 'left',
            prop: 'orderStatus',
            isShow: true,
            'min-width': 100,
            'show-overflow-tooltip': true,
            formatter: (params) => {
              if (params.orderStatus || params.orderStatus === 0) {
                return this.$consts.orderStatisText[params.orderStatus]
              } else {
                return '-'
              }
            }
          },
          {
            label: '投放总量(PV)',
            align: 'right',
            prop: 'totalTraffic',
            'min-width': 150,
            isShow: true,
            'show-overflow-tooltip': true,
            formatter: (params) => {
              return (params.totalContract + params.freeTotalTraffic + params.addedTotalTraffic).toLocaleString()
            }
          },
          {
            label: '排期量(PV)',
            align: 'right',
            prop: 'totalContract',
            'min-width': 150,
            isShow: true,
            'show-overflow-tooltip': true,
            formatter: (params) => {
              if (params.totalContract) {
                return params.totalContract.toLocaleString()
              } else {
                return 0
              }
            }
          },
          {
            label: '赠送量(PV)',
            align: 'right',
            prop: 'freeTotalTraffic',
            'min-width': 150,
            isShow: true,
            'show-overflow-tooltip': true,
            formatter: (params) => {
              if (params.freeTotalTraffic) {
                return params.freeTotalTraffic.toLocaleString()
              } else {
                return 0
              }
            }
          },
          {
            label: '补量(PV)',
            align: 'right',
            prop: 'addedTotalTraffic',
            'min-width': 150,
            isShow: true,
            'show-overflow-tooltip': true,
            formatter: (params) => {
              return (params.addedTotalTraffic || 0).toLocaleString()
            }
          },
          {
            label: '曝光量(PV)',
            align: 'right',
            prop: 'oSendAmount',
            'min-width': 150,
            isShow: true,
            'show-overflow-tooltip': true,
            formatter: (params) => {
              if (params.oSendAmount) {
                return params.oSendAmount.toLocaleString()
              } else {
                return 0
              }
            }
          },
          {
            label: '投放时间',
            align: 'left',
            prop: 'contractBeginDate',
            'min-width': 220,
            isShow: true,
            'show-overflow-tooltip': true,
            formatter: (params) => {
              if (params.contractBeginDate || params.contractEndDate) {
                return (
                  this.$moment(params.contractBeginDate).format('YYYY-MM-DD') +
                  ' ~ ' +
                  this.$moment(params.contractEndDate).format('YYYY-MM-DD')
                )
              } else {
                return '-'
              }
            }
          },
          {
            label: '购买方式',
            align: 'left',
            prop: 'buyType',
            'min-width': 220,
            isShow: true,
            'show-overflow-tooltip': true,
            formatter: (row) => {
              if (row.buyType === 1) {
                return '竞价购买'
              } else {
                return '合约排期'
              }
            }
          },
          {
            label: '创建时间',
            align: 'left',
            prop: 'createTime',
            isShow: true,
            'min-width': 200,
            'show-overflow-tooltip': true,
            render: (h, { row }) => {
              return h('TimeFormat', {
                props: {
                  value: row.createTime
                }
              })
            }
          },
          {
            label: '订单ID',
            align: 'right',
            prop: 'orderId',
            isShow: true,
            'min-width': 100,
            'show-overflow-tooltip': true
          },
          {
            label: '操作栏',
            align: 'left',
            'min-width': 190,
            fixed: 'right',
            isShow: true,
            render: (h, { row }) => {
              const disabled = row.orderStatus === -1 || row.orderStatus === 1
              return h('div', [
                h(
                  'el-button',
                  {
                    props: {
                      type: 'text',
                      disabled
                    },
                    class: 'el-table-button-text',
                    on: {
                      click: (event) => {
                        event.stopPropagation()
                        this.handleEdit(row)
                      }
                    },
                    directives: [
                      {
                        name: 'permission',
                        value: 'order:edit'
                      }
                    ]
                  },
                  '编辑'
                ),
                h(
                  'el-button',
                  {
                    props: {
                      type: 'text'
                    },
                    class: 'el-table-button-text',
                    on: {
                      click: (event) => {
                        event.stopPropagation()
                        this.handleRead(row, 1)
                      }
                    },
                    directives: [
                      {
                        name: 'permission',
                        value: 'order:dataOne'
                      }
                    ]
                  },
                  '详情'
                ),
                h(
                  'el-button',
                  {
                    props: {
                      type: 'text'
                    },
                    class: 'el-table-button-text',
                    on: {
                      click: (event) => {
                        event.stopPropagation()
                        this.seeOrderChartsData(row)
                      }
                    },
                    directives: [
                      {
                        name: 'permission',
                        value: 'order:data'
                      }
                    ]
                  },
                  '数据'
                ),
                h(
                  'el-dropdown',
                  {
                    props: {
                      trigger: 'click'
                    },
                    style: {
                      'margin-left': '10px'
                    },
                    on: {
                      command: (event) => {
                        this.handleCommand(row, event)
                      }
                    }
                  },
                  [
                    h('span', {
                      class: 'el-icon-more',
                      style: {
                        color: '#1890FF',
                        lineHeight: '24px',
                        cursor: 'pointer',
                        transform: 'rotate(90deg)'
                      }
                    }),
                    h(
                      'el-dropdown-menu',
                      {
                        slot: 'dropdown',
                        style: {
                          'width': '120px'
                        }
                      },
                      [
                        h(
                          'el-dropdown-item',
                          {
                            props: {
                              command: 'log'
                            },
                            on: {
                              click: (event) => {
                                event.stopPropagation()
                                this.handleRead(row, 2)
                              }
                            },
                            directives: [
                              {
                                name: 'permission',
                                value: 'order:log'
                              }
                            ]
                          },
                          '日志'
                        ),
                        h(
                          'el-dropdown-item',
                          {
                            props: {
                              command: 'delete',
                              disabled: row.orderStatus !== 0 && row.orderStatus !== 2
                            },
                            directives: [
                              {
                                name: 'permission',
                                value: 'order:operate'
                              }
                            ]
                          },
                          '删除'
                        )
                      ]
                    )
                  ]
                )
              ])
            }
          }
        ],
        data: [],
        selected: [],
        selectionType: 'multiple'
      },
      selected: [],
      selectedRow: [],
      tagsListTableHeader: [],
      dictOrderTagMap: {}
    }
  },
  computed: {
    tableHeader() {
      let header = []
      header = this.table.header
        .filter((item) => item.isShow === true)
        .concat(this.tagsListTableHeader)
      return header
    }
  },
  watch: {
    'projectOrder.searchParam'(newValue, oldValue) {
      this.currentPage = 1
      this.pageSize = 10
      this.selected = []
      this.table.selected = []
      this.selectedRow = []
    },
    'projectOrder.selectForm': {
      handler(newVal, oldVal) {
        this.currentPage = 1
        this.pageSize = 10
        this.selected = []
        this.table.selected = []
        this.selectedRow = []
        this.fetchDataDebounced()
      }
      // deep: true
    },
    'projectOrder.timeList': {
      handler() {
        this.fetchData()
      }
      // deep: true
    },
    selected: {
      handler(newValue, oldVal) {
        if (newValue.length > 0) {
          this.buttonList.forEach((item) => {
            item.disabled = false
          })
        } else {
          this.buttonList.forEach((item) => {
            item.disabled = true
          })
        }
      }
      // deep: true
    }
  },
  methods: {
    // 关闭详情抽屉

    handleCloseDraw() {
      this.drawer = false
    },
    getTableOpen() {
      if (this.$appState.$get('permissions')['order:operate']) {
        return true
      } else {
        return false
      }
    },
    fetchData() {
      this.loading = true
      this.filter.pageNo = this.currentPage
      this.filter.pageSize = this.pageSize
      // 订单状态
      if (
        this.projectOrder.selectForm.orderStatus ||
        this.projectOrder.selectForm.orderStatus === 0
      ) {
        this.filter.orderStatus = this.projectOrder.selectForm.orderStatus
      } else {
        this.filter.orderStatus = undefined
      }
      // 广告主
      this.filter.partnerName = this.projectOrder.selectForm.orderPartnerName
        ? this.projectOrder.selectForm.orderPartnerName
        : undefined
      // 订单投放时间 当全部和外部时间都有时，按照全部时间来筛选
      if (this.projectOrder.selectForm.contractTime) {
        this.filter.startDateX = this.$moment(
          this.projectOrder.selectForm.contractTime[0]
        ).format('YYYY-MM-DD 00:00:00')
        this.filter.endDateX = this.$moment(
          this.projectOrder.selectForm.contractTime[1]
        ).format('YYYY-MM-DD 23:59:59')
      } else {
        if (this.projectOrder.timeList) {
          this.filter.startDateX = this.$moment(this.projectOrder.timeList[0]).format(
            'YYYY-MM-DD 00:00:00'
          )
          this.filter.endDateX = this.$moment(this.projectOrder.timeList[1]).format(
            'YYYY-MM-DD 23:59:59'
          )
        } else {
          this.filter.startDateX = undefined
          this.filter.endDateX = undefined
        }
      }
      // 购买方式
      this.filter.buyType =
        this.projectOrder.selectForm.buyType !== ''
          ? this.projectOrder.selectForm.buyType
          : undefined
      // 检索名称或单号
      if (this.projectOrder.selectNameType === 0) {
        // 只有当前选择的名字是订单的时候，才查询订单名字或id
        this.filter.searchParam = this.projectOrder.searchParam
      } else {
        this.filter.searchParam = undefined
      }
      this.$service
        .getOrderList(this.filter)
        .then((data) => {
          this.totalCount = data.total
          // this.table.data = []
          this.$nextTick(() => {
            this.table.data = data.rows
            this.updateTableSelected()
            this.loading = false
          })
        })
        .catch((e) => {
          this.loading = false
        })
    },
    // 获取指定数据字典
    queryDictData() {
      return new Promise((resolve, reject) => {
        this.$service.queryDictData({ type: 'order_tag' }).then((data) => {
          this.dictOrderTagMap = (data || []).slice().reduce((result, item) => {
            result[item.label] = item.value
            return result
          }, {})
          resolve(this.dictOrderTagMap)
        })
      })
    },
    // 获取订单标签
    getOrderTags() {
      return this.$service.getOrderTags().then((data) => {
        this.tagsListTableHeader = data.map((item) => {
          const value = this.dictOrderTagMap[item.mediaTagTypeName]
          return {
            label: item.mediaTagTypeName,
            prop: value,
            align: 'left',
            'min-width': 100,
            isShow: true,
            'show-overflow-tooltip': true,
            formatter: (row) => {
              if (!row[value]) {
                return '-'
              } else {
                return row[value]
              }
            }
          }
        })
      })
    },
    handleCreate() {
      this.$emit('create')
    },
    handleRead(row, flage) {
      this.drawer = true
      this.detailOrderId = row.orderId
      this.flage = flage
    },
    handleEdit(row) {
      this.$emit('edit', row)
    },
    seeOrderChartsData(row) {
      this.$router.push({ name: 'orderBasicData', params: { order: row } })
    },
    handleDisplayOtherMethod() {
      this.isShowPopover = false
      this.$refs.popover.showPopper = true
    },
    OnCheckList(value) {
      this.buttonListMethodMaps[value]()
    },
    // 只有暂停的订单可以启用：2
    handleStartOrder() {
      const result = this.selectedRow
        .filter((item) => item.orderStatus === 2)
        .map((e) => e.orderId)
      if (result.length > 0) {
        const obj = {
          ids: result,
          operateType: 1
        }
        this.$service.updateOrder(obj).then((data) => {
          if (data.code === 0) {
            this.fetchData()
            this.table.selected = []
            this.selected = []
            this.selectedRow = []
            this.$message.success('已为您启用' + result.length + '条订单')
          } else {
            this.$message.error('启用失败，请重试')
          }
        })
      } else {
        this.$message('没有符合启用的订单')
      }
    },
    // 只有暂停的订单能启用：0
    handlePauseOrder() {
      const result = this.selectedRow
        .filter((item) => item.orderStatus === 0)
        .map((e) => e.orderId)
      if (result.length > 0) {
        const obj = {
          ids: result,
          operateType: 2
        }
        this.$service.updateOrder(obj).then((data) => {
          if (data.code === 0) {
            this.fetchData()
            this.table.selected = []
            this.selected = []
            this.selectedRow = []
            this.$message.success('已为您暂停' + result.length + '条订单')
          } else {
            this.$message.error('暂停失败，请重试')
          }
        })
      } else {
        this.$message('没有符合暂停的订单')
      }
    },
    // 只有启用和暂停的订单才可以结束: 0,2
    handleEndOrder() {
      const result = this.selectedRow
        .filter((item) => item.orderStatus === 0 || item.orderStatus === 2)
        .map((e) => e.orderId)
      if (result.length > 0) {
        const obj = {
          ids: result,
          operateType: 3
        }
        this.$confirm(
          '结束操作，系统会自动结束订单及订单下的广告计划，并不能再次被使用，请确认是否执行？',
          '提示',
          {
            showClose: false,
            center: true
          }
        ).then(() => {
          this.$service.updateOrder(obj).then((data) => {
            if (data.code === 0) {
              this.fetchData()
              this.table.selected = []
              this.selected = []
              this.selectedRow = []
              this.$message.success('已为您结束' + result.length + '条订单')
            } else {
              this.$message.error('结束失败，请重试')
            }
          })
        })
      } else {
        this.$message('没有符合结束的订单')
      }
    },
    // 订单为启用暂停并且订单下下仅有【草稿】和【审核不通过】状态计划单，或无计划单条件下可删除
    handleDelOrder() {
      let result = this.selectedRow
        .filter((item) => item.orderStatus === 0 || item.orderStatus === 2)
        .map((e) => e.orderId)
      if (result.length > 0) {
        // 判断是否可以删除
        this.$service.selectCanDeleteOrderIds(result).then((data) => {
          result = data
          this.handleOperateOrder(result)
        })
      } else {
        this.$message('没有符合删除的订单')
      }
    },
    handleOperateOrder(arr) {
      const obj = {
        ids: arr,
        operateType: 4
      }
      if (arr.length > 0) {
        const textDelete =
          '删除操作，系统会自动结束订单及订单下的广告计划，并不能再次被使用，请确认是否执行?'
        this.$confirm(textDelete, '提示', {
          showClose: false,
          center: true
        })
          .then(() => {
            this.$service.updateOrder(obj).then((data) => {
              if (data.code === 0) {
                this.$message.success('已为您删除' + arr.length + '条订单')
                this.fetchData()
                this.table.selected = []
                this.selected = []
                this.selectedRow = []
              } else {
                this.$message.error('删除失败，请重试')
              }
            })
          })
          .catch(() => {})
      } else {
        this.$message('没有符合删除条件的订单')
      }
    },
    handleChangeTableHeader(e) {
      e.isCheck = !e.isCheck
      let index = this.table.header.findIndex((item) => item.label === e.label)
      this.table.header[index].isShow = e.isCheck
      this.$store.commit('saveProjectTable', this.table.header)
    },
    // 表格操作
    handleRefresh() {
      this.currentPage = 1
      this.filter = {}
      this.fetchData()
    },
    // 每页显示数据量变更,  如每页显示10条变成每页显示20时,val=20
    handleSizeChange(val) {
      this.pageSize = val
      this.fetchData()
    },
    // 页码变更, 如第1页变成第2页时,val=2
    handleCurrentChange(val) {
      this.currentPage = val
      this.fetchData()
    },
    handleRowSelectionAdd(targetItem) {
      this.selected.push(targetItem.orderId)
      this.selectedRow.push(targetItem)
      this.updateTableSelected()
    },
    handleRowSelectionRemove(targetItem) {
      this.selected = this.selected.filter((item) => {
        return item !== targetItem.orderId
      })
      this.selectedRow = this.selectedRow.filter((item) => {
        return item.orderId !== targetItem.orderId
      })
      this.updateTableSelected()
    },
    handleAllRowSelectionChange(value) {
      if (value) {
        this.table.data.forEach(this.handleRowSelectionAdd)
      } else {
        this.selected = []
        this.selectedRow = []
        this.table.selected = []
      }
    },
    handleAllRowSelectionRemove() {
      this.selected = []
      this.selectedRow = []
      this.table.selected = []
    },
    updateTableSelected() {
      const table = this.table
      const newSelectedIndex = this.selected
      table.selected = table.data.reduce((result, item, index) => {
        if (newSelectedIndex.indexOf(item.orderId) > -1) {
          result.push(index)
        }
        return result
      }, [])
    },
    handleFilterChange(type, filter) {
      if (filter) {
        this.filter = filter
      }
      if (type === 'query') {
        this.pagination.currentPage = 1
      }
      this.fetchData()
    },
    handleOpenDrawer() {
      // this.fetchData()
    },
    handleCommand(e, command) {
      if (command === 'delete') {
        // 操作栏删除，订单下仅有【草稿】和【审核不通过】状态计划单，或无计划单可删除，先判断是否满足条件，在二次确认
        //  if() {
        //     this.$message.error('操作成功')
        //  } else {
        //    this.$message.error('订单包含正在使用的计划单，无法删除')
        //  }
        let obj = {
          ids: [e.orderId],
          operateType: 4
        }
        this.$service.selectCanDeleteOrderIds(obj.ids).then((data) => {
          obj.ids = data || []
          if (obj.ids.length > 0) {
            this.$confirm(
              '删除操作，系统会自动结束订单及订单下的广告计划，并不能再次被使用，请确认是否执行？',
              '提示',
              {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                showClose: false,

                center: true
              }
            )
              .then(() => {
                this.$service.updateOrder(obj).then((data) => {
                  this.$message.success('已为您删除1条订单')
                  this.fetchData()
                  this.selected = []
                  this.table.selected = []
                })
              })
              .catch(() => {})
          } else {
            this.$message.error('订单包含正在使用的计划单，无法删除')
          }
        })
      } else {
        this.handleRead(e)
      }
    },
    // 获取一口价广告位信息
    getSpace() {
      this.$service.getSpace().then((res) => {
        this.priceData = JSON.parse(JSON.stringify(res.spaceList))
        this.priceData.map((item) => {
          item.isShow = true
        })
      })
    }
  },
  async created() {
    this.table.data = []
    await this.queryDictData()
    await this.getOrderTags()
    this.fetchData()
    this.getSpace()
    this.fetchDataDebounced = debounce(this.fetchData, 500)
  }
}
</script>
<style lang="stylus" scoped>
.page-content
  padding 0 16px
>>> .table-input input
  border none
  line-height 22px
  height 22px
.table-header-button
  border none !important
.el-tabs--border-card
  border none
>>> .el-tabs--border-card>.el-tabs__header
  border none
>>>.el-table-button-text
  color #1890FF
>>>.el-table-button-text.is-disabled
  color #C0C4CC
>>>.table-status
  display flex
  flex-direction row
  align-items center
</style>
